import store from '../../../store/store';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { ACTION_SETTINGS_URL } from './action-api-urls';
import { ShopActionSettings } from './action-types';

export interface UpdateActionSettingsRequest {
  monthly_budget_cap?: number | null;
  notification_email?: string | null;
  notification_webhook?: string | null;
  require_approval_above?: number | null;
  is_active?: boolean;
}

export interface UpdateActionSettingsResponse {
  success: boolean;
  message: string | null;
  data: ShopActionSettings | null;
}

export default async function update_action_settings_api_call(
  settingsData: UpdateActionSettingsRequest
): Promise<ShopActionSettings | null> {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const accessToken = store.getState().auth.authorization.accessToken;
    const sellerToken = accessToken?.sellerToken;

    const requestInfo: RequestInfo = {
      url: ACTION_SETTINGS_URL(shopSlug),
      method: 'PUT',
      body: JSON.stringify(settingsData),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: accessToken.type + ' ' + sellerToken,
      },
    };

    const actionType = 'UPDATE_ACTION_SETTINGS';
    const customMsg = 'Action settings updated successfully.';

    const res: any = await asyncHandler(
      requestInfo,
      actionType,
      customMsg,
      true,
      false
    );

    const response: UpdateActionSettingsResponse = res?.data;

    if (res?.actionType === actionType && response?.success === true) {
      return response.data;
    } else {
      return null;
    }
  } catch (exception) {
    console.log('Error during update action settings request');
    return null;
  }
}
